import type { App } from 'vue';
import type { Router } from 'vue-router';

import { ENV, ENV_PRODUCTION, SENTRY_KEY } from '@/shared/config';

export async function initSentry(app: App<Element>, router: Router): Promise<void> {
  const { init, browserTracingIntegration } = await import('@sentry/vue');

  if (ENV_PRODUCTION && SENTRY_KEY) {
    init({
      app,
      dsn: SENTRY_KEY,
      environment: ENV,
      tracePropagationTargets: ['cloud.hubgridcloud.com'],
      integrations: [
        browserTracingIntegration({
          router,
        }),
      ],
      tracesSampleRate: 1.0,
    });
  }
}
